import { Typography } from '@/components/UI/Typography'
import type { FC } from 'react'

export type PointRallyCourseCardProps = {
  /** コース名 */
  courseName: string
  /** 獲得済みポイント数 */
  earnedPoints: number
  /** 「獲得履歴を表示する」ボタン押下時のコールバック */
  onClickHistory?: () => void
}

/** ポイントラリー コースカード（Figma: 455:12661） */
export const PointRallyCourseCard: FC<PointRallyCourseCardProps> = ({ courseName, earnedPoints, onClickHistory }) => {
  return (
    <div className="w-full bg-white border border-[#cbcbce] rounded-[8px] h-[166px] relative">
      {/* コース名 */}
      <Typography variant="body1" className="absolute left-[32px] top-[16px] tracking-[-0.15px]">
        {courseName}
      </Typography>

      {/* ポイント表示 */}
      <p className="absolute left-[32px] top-[50px] text-black leading-none">
        <Typography variant="h1" component="span">
          {earnedPoints}
        </Typography>
        <Typography variant="body1" component="span">
          ポイント
        </Typography>
      </p>

      {/* 獲得履歴ボタン */}
      <div className="absolute left-1/2 -translate-x-1/2 top-[112px]">
        <button
          type="button"
          onClick={onClickHistory}
          className="flex h-[36px] w-[311px] items-center justify-center rounded-[8px] border border-[#757575] bg-white px-[32px] py-[16px]"
        >
          <Typography variant="button2" component="span" c="#757575" className="whitespace-nowrap">
            獲得履歴を表示する
          </Typography>
        </button>
      </div>
    </div>
  )
}
